import { styled, css } from "../../style";

const StyledButton = styled("div")(
  ({ theme }) => css`
    .maximus-price {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 700;
      color: ${theme.colors.primaryText};
      text-shadow: 0 0 8px ${theme.mint};
      margin-right: ${theme.spacing3};

      > img {
        width: auto;
        height: 32px;
        margin-right: ${theme.spacing3};
        margin-left: ${theme.spacing2};
        transition: all 0.2s ease-in-out;
      }

      &:hover {
        > img {
          transform: scale(1.2);
        }
      }
    }
  `
);

export default StyledButton;
